<template>
  <div class="aco-grid">
    <div class="aco-info-box">
      <usage-filter/>
    </div>
    <div class="aco-details-box">
      <usage-list/>
    </div>
  </div>
</template>

<script>
  import UsageFilter from './UsageFilter'
  import UsageList from './UsageList'

  export default {
    components: {
      usageFilter: UsageFilter,
      usageList: UsageList
    }
  }
</script>
